import React from 'react';


const TableHeader = () => (
  <div className="stats-view--table--header--wrapper">
    <div className="stats-view--table--header">
      <div className="stats-view--table--header-item stats-view--table--id">Id</div>
      <div className="stats-view--table--header-item stats-view--table--name">Název</div>
      <div className="stats-view--table--header-item stats-view--table--desk">Přepážky</div>
      <div className="stats-view--table--header-item stats-view--table--clients">Odbavených</div>
      <div className="stats-view--table--header-item stats-view--table--max-len">Maximální doba čekání</div>
      <div className="stats-view--table--header-item stats-view--table--wait-cli">Čekajících klientů</div>
      <div className="stats-view--table--header-item stats-view--table--wait-avg">Průměrná doba čekání</div>
      <div className="stats-view--table--header-item stats-view--table--last">Poslední vyvolaný</div>
    </div>
  </div>
);


export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/Stats/TableHeader.js